import { Copy } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import type { ToggleProps } from 'src/v2/commonComponents/DrawerTooltipContainer';

export const CopyMessageToggle = ({
  id,
  isActive,
  disabled,
  onClick,
}: ToggleProps) => {
  return (
    <div id={id}>
      <Button
        color={isActive ? 'tertiary' : 'secondary-outline'}
        onClick={onClick}
        disabled={disabled}
        tooltipContent={!isActive ? 'Copy' : undefined}
      >
        <Copy size={SVG_SIZE_M} />
        <span>Copy</span>
      </Button>
    </div>
  );
};
